module.exports = __webpack_public_path__ + "static/media/airtime.db2bdf20.csv";